import { NEUTRAL_400, NEUTRAL_200 } from 'visitor-ui-component-library/constants/WidgetColors';
const defaultFileAttachmentTheme = {
  tileBackgroundColor: NEUTRAL_200,
  tileBorderColor: NEUTRAL_400
};
const FileAttachmentTheme = themeProps => Object.assign({}, defaultFileAttachmentTheme, themeProps);
export default FileAttachmentTheme;